import Sidebar from "@/components/Sidebar/SidebarView.vue";
import Navbar from '@/components/HomeNavBar/HomeNavBar.vue';
import InactivityModal from "@/components/InactivityTracker/InactivityTracker.vue";
import { get_token } from "@/router";
import Swal from "sweetalert2";
import {
  format_currency,
  format_date,
  get_campaign_raised_amount,
  get_campaign_summary,
  get_progress,
} from "@/views/DonationCampaigns/donation_campaigns_methods_helper";

export default {
  name: "DonationCampaignDashboardView",
  components: {
    Sidebar,
    Navbar,
    InactivityModal,
  },
  data() {
    return ({
      campaigns: [],
      campaign_dashboard: {},
      is_loading: false,
    });
  },
  computed: {
    total_raised_amount() {
      return this.campaigns.reduce(
        (total, campaign) => total + Number(this.get_campaign_raised_amount(campaign) || 0),
        0
      );
    },
    total_goal_amount() {
      return this.campaigns.reduce(
        (total, campaign) => total + Number(campaign?.goal_amount || 0),
        0
      );
    },
    total_donations_count() {
      return this.campaigns.reduce((total, campaign) => {
        const completed_donations = Array.isArray(campaign?.donations)
          ? campaign.donations.filter(
            (donation) => String(donation?.donation_status || "").toLowerCase() === "completed"
          )
          : [];

        return total + completed_donations.length;
      }, 0);
    },
    active_campaigns_count() {
      return this.campaigns.filter(
        (campaign) => String(campaign?.status || "").toLowerCase() === "active"
      ).length;
    },
    donation_dashboard_cards() {
      return [
        { label: "Total Campaigns", value: this.get_dashboard_count("total_count", this.campaigns.length), icon: "bi-megaphone-fill", tone: "primary" },
        { label: "Active", value: this.get_dashboard_count("active_count", this.active_campaigns_count), icon: "bi-play-circle-fill", tone: "success" },
        { label: "Completed", value: this.get_dashboard_count("completed_count"), icon: "bi-check-circle-fill", tone: "info" },
        { label: "Paused", value: this.get_dashboard_count("paused_count"), icon: "bi-pause-circle-fill", tone: "warning" },
        { label: "Pinned", value: this.get_dashboard_count("pinned_count"), icon: "bi-pin-angle-fill", tone: "danger" },
        { label: "Donations", value: this.get_dashboard_count("total_donation_count", this.total_donations_count), icon: "bi-heart-fill", tone: "danger" },
        { label: "Donors", value: this.get_dashboard_count("unique_donor_count"), icon: "bi-people-fill", tone: "info" },
      ];
    },
  },
  mounted() {
    this.fetch_campaigns();
  },
  methods: {
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },
    getToken() {
      return get_token();
    },
    get_request_headers() {
      return ({
        Authorization: `Token ${this.getToken()}`,
      });
    },
    init_campaigns_datatable() {
      const table_id = "#campaignDashboardTable";
      const table = $(table_id);

      if (!table.length || !$.fn.DataTable) {
        return;
      }

      if ($.fn.DataTable.isDataTable(table_id)) {
        table.DataTable().clear().destroy();
      }

      table.DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        lengthChange: true,
        pageLength: 10,
        order: [[5, "desc"]],
        language: {
          paginate: {
            previous: "Previous",
            next: "Next",
          },
          info: "Showing _START_ to _END_ of _TOTAL_ campaigns",
          infoEmpty: "No campaigns available",
          emptyTable: "No campaigns available",
        },
      });
    },
    destroy_campaigns_datatable() {
      const table_id = "#campaignDashboardTable";

      if ($.fn.DataTable?.isDataTable?.(table_id)) {
        $(table_id).DataTable().clear().destroy();
      }
    },
    fetch_campaigns() {
      this.is_loading = true;
      this.destroy_campaigns_datatable();

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/donation_management/get_campaigns/`,
        method: "GET",
        headers: this.get_request_headers(),
        success: (response) => {
          this.campaigns = response?.data || [];
          this.campaign_dashboard = response?.dashboard || {};
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "Unable to load campaigns.",
            showConfirmButton: false,
            timer: 2200,
            position: "bottom-end",
            toast: true,
          });
        },
        complete: () => {
          this.is_loading = false;
          this.$nextTick(() => {
            if (this.campaigns.length) {
              this.init_campaigns_datatable();
            }
          });
        },
      });
    },
    get_dashboard_count(key, fallback = 0) {
      const value = Reflect.get(this.campaign_dashboard || {}, key);
      return Number(value ?? fallback) || 0;
    },
    open_campaign(campaign) {
      if (!campaign?.id) {
        return;
      }

      this.$router.push({
        name: "donation_campaigns",
        query: { campaign_id: campaign.id },
      });
    },
    go_to_create_campaign_page() {
      this.$router.push({
        name: "my_donation_campaigns",
        query: { tab: "create" },
      });
    },
    get_campaign_donor_count(campaign) {
      if (!Array.isArray(campaign?.donations)) {
        return 0;
      }

      return campaign.donations.filter(
        (donation) => String(donation?.donation_status || "").toLowerCase() === "completed"
      ).length;
    },
    format_currency,
    format_date,
    get_campaign_summary,
    get_campaign_raised_amount,
    get_progress,
  },
};
